export const environment = {
  production: true,
  environment_name: "glen",
  environment_title: "The Glen",
  environment: "prod",
  api_base_url: "https://api.hyprop.co.za/",
  api_auth_url: "https://auth-api.hyprop.co.za/",
  cdn_url: "https://cdn.hyprop.co.za/",
  mall_id: "c9ba5816-86fe-41a8-ae04-81b422e9e998",
  addressLat: -26.2681502865095,
  addressLng: 28.04845615505492,
  cinemaID: 17,
  recaptcha_key: "6LeJuCcbAAAAAMiZ_rBgq7NTiEQVrjNZ1J6f1zAL",
  social_google_key:
    "150343683952-08m97b42cr2fc2v4j1qnckfmq1np0hn9.apps.googleusercontent.com",
  social_facebook_key: "253233436432992",
  sso_url: "https://sso.hyprop.co.za",
  google_verification: "eNdAxNdbdeStqQz70pU99c6Rw0z_IXSvYXg8cZItrMI",
  street_address: "Cnr Orpen Rd &, Letaba Rd",
  address_locality: "Oakdene",
  postal_code: "2001",
  address_country: "ZA",
  contact_form_uuid: "qs65jeim",
  google_api_key: "AIzaSyCEvUD2-2IuJdnY4mCmiPHjrdjDsskcTG8",
};
